import {Base} from "@/api/Base"

export class HolidayEdit extends Base {
    path = "holiday/edit"
}